<div class="loader loading-screen-wrapper" *ngIf="showLoader">
  <mat-spinner class="loading-screen-icon" diameter=75></mat-spinner>
</div>
